export enum PipelineStatus {
  Succeeded = 'Succeeded',
  Queued = 'Queued',
  InProgress = 'InProgress',
  Failed = 'Failed',
  Canceling = 'Canceling',
  Cancelled = 'Cancelled'
}
